/**
 * @see net/disy/cadenza/repository/conditions/ConditionType.java
 */
export type ConditionType = 'TableCondition' | 'AreaCondition' | 'ChoiceCondition' | 'FormCondition' | 'ValueIntervalCondition'
| 'TwoAttributesValueIntervalCondition' | 'DateCondition' | 'DateIntervalCondition' | 'BoundingBoxCondition'
| 'PolygonCondition' | 'TreeCondition' | 'MapCondition' | 'GeoCondition' | 'FlowingWaterCondition'
| 'ValueIntervalHistogramCondition' | 'MeasuredFlowingWaterCondition' | 'DistanceCondition'
| 'WindowingGeometryCondition' | 'LikeCondition' | 'OracleTextCondition' | 'AlwaysFalseCondition'
| 'QlCondition' | 'IpAddressCondition';

/** @deprecated Use the type instead */
export const ConditionType = {
  TABLE_CONDITION: 'TableCondition',
  LIKE_CONDITION: 'LikeCondition',
  DATE_CONDITION: 'DateCondition',
  VALUE_INTERVAL_CONDITION: 'ValueIntervalCondition',
  QL_CONDITION: 'QlCondition',
  DATE_INTERVAL_CONDITION: 'DateIntervalCondition',
  TREE_CONDITION: 'TreeCondition',
  SPATIAL_CONDITION: 'PolygonCondition', // Under the hood, in the backend, PolygonCondition is used
  IP_ADDRESS_CONDITION: 'IpAddressCondition'
} as const;
